const singleProduct = {
  init() {
    const $ = jQuery;
    // PDP Product variation name changes
    const $variationsTable           = $( '.summary .variations_form .variations' );
    const $variationListItem         = $( '.single-product .summary .variable-items-wrapper li' );
    const $selectedVariationListItem = $( '.variable-items-wrapper li.selected' );
    const $stickyFormProduct         = $( '.add-to-cart-sticky-footer__product-name' );

    $variationListItem.on( 'click', function( e ) {
      let selectedColorName = $(this).attr( 'data-wvstooltip' );
      $( '.selected-variation-name' ).html( selectedColorName );
      $( '.add-to-cart-sticky-footer__selected-variation' ).html( selectedColorName );
    });

    $( '.woo-variation-raw-select' ).on( 'change', function(e) {
      let selectedColorName = $(this).val();
      //capitalize first letter and replace dashes with spaces
      selectedColorName = selectedColorName.charAt(0).toUpperCase() + selectedColorName.slice(1).replace(/-/g, ' ');

      //let selectedColorName = $( this ).attr('title');
      $( '.selected-variation-name' ).html( selectedColorName );
    })

    if ( $selectedVariationListItem.length > 0 ) {
      let selectedColorName = $selectedVariationListItem.attr('data-wvstooltip');
      $( '.selected-variation-name' ).html( '<span class="bold"></span> ' + selectedColorName );
    }

    $('.product-specs a').click(function(e) {
      e.preventDefault();
    });

    // When variation is changed, get the new price & product variation Tag (if applicable)
    $( 'form.variations_form' ).on( 'show_variation', function( event, variation ) {
      updateCustomizerUrl( variation );
      updateSingleProductVariablePrice();
      updateVariationTag( variation );
    });

    let default_variation_customizer_url = '';
    function updateCustomizerUrl( variation ) {
      let customizer_url = variation.nalgene_customizer_url;
      if ( customizer_url !== '' ) {
        $( '#nalgene-customizer-link' ).attr( "href", customizer_url );
        if( '' == default_variation_customizer_url ) default_variation_customizer_url = customizer_url;
      } else {
        $( '#nalgene-customizer-link' ).attr( "href", default_variation_customizer_url );
      }
    }

    function updateSingleProductVariablePrice() {
      let newPrice = $( '.woocommerce-variation-price' ).html();
      if ( newPrice !== '' ) {
        $( '.summary p.price' ).html( newPrice );
      }
    }

    function updateVariationTag( variation ) {
      let variation_tag = variation.variation_tag;
      let variation_tag_color = variation.variation_tag_color;
      let tagExists = $('span.pill');

      if ( tagExists ) {
        tagExists.remove();
      }

      if ( typeof variation_tag !== 'undefined' ) {
        let summaryDiv = $( '.single-product .summary' );
        let tag = $('<span>' + variation_tag + '</span>');
        tag.addClass('pill tag-pill');
        tag.css('background-color', variation_tag_color);
        summaryDiv.prepend( tag );
      }

    }

    jQuery( 'li[data-action="swatch_update_product_image"]' ).on( 'click', function( e ) {
      let variationPrice = jQuery( this ).find( '.hidden-variation-price' ).html();
      var newImage = jQuery( this ).data( 'product-image' );

      if ( newImage == '' ) {
        console.error( 'No variation image found for this Product' );
      } else {

        jQuery( this ).parents( 'div.add-on-product' ).find( '.add-on-product__image-container img' ).attr({
          src: newImage,
          srcset: newImage
        });

        jQuery( this ).parents( 'li.product' ).find( '.product__image-container img' ).attr( {
          src: newImage,
          srcset: newImage
        });
      }

      var newName = jQuery( this ).data( 'variation-name' );
      jQuery( this ).parents( 'li.product' ).find( '.single-variation-name' ).text( newName );

      if ( variationPrice ) {
        jQuery( this ).parents( 'div.add-on-product' ).find('.price-container').html( variationPrice );
      }

      jQuery( this ).addClass( 'selected' );
      jQuery( this ).siblings().removeClass( 'selected' );

      let variationUrl = $(this).attr('data-product-url');
      jQuery( this ).parents( 'div.add-on-product' ).find('a').attr( 'href', variationUrl );
      jQuery( this ).parents( 'li.product' ).find( 'a' ).attr( 'href', variationUrl );
    });

    $( '.related-products li.add-on-product__variation-item' ).on( 'click', function( e ) {
      let variationId = $( this ).attr('data-variation-id');
      let itemIndex   = $( this ).parents('div.add-on-product').index();
      let dataProducts = JSON.parse( $('.add-both-to-cart__button').attr('data-products') );
      dataProducts[itemIndex] = variationId;
      $('[data-action="add-to-cart"]').attr('data-products', JSON.stringify(dataProducts) );

      var newTotalPrice = 0;
      $('.bought-together .price-container .amount').each( function( index, element ) {

        var noDollarSign = $( this ).text().replace( "$", "" );
        var price = parseFloat( noDollarSign );
        newTotalPrice += price;
      });

      newTotalPrice = parseFloat(newTotalPrice).toFixed(2);
      $('.add-both-to-cart__price span').html( '$' + newTotalPrice );
    });

    function searchArrGetImage( nameKey, myArray ) {
      for ( var i = 0; i < myArray.length; i++ ) {
        if ( myArray[i].attributes.attribute_pa_color === nameKey ) {
          return myArray[i].variation_id;
        }
      }

      for ( var i = 0; i < myArray.length; i++ ) {
        if ( myArray[i].attributes.attribute_pa_graphic === nameKey ) {
          return myArray[i].variation_id;
        }
      }
    }
  },

}
export default singleProduct
